<template>
  <div class="home-box mt-15">
    <div class="d-flex align-center justify-center flex-column">
      <v-layout row v-if="errors" class="my-5">
          <v-flex>
            <Alert @dismissed="onDismissed" :text="errors"></Alert>
          </v-flex>
        </v-layout>
      <v-card class="d-flex align-center justify-center flex-column pa-5" style="width:50rem; min-height: 20rem;">
        <v-col
          cols="12"
          md="9"
          xs="6"
          class="d-flex align-center justify-center flex-column"
        >
        <v-progress-linear class="ma-2" v-if="loading" indeterminate color="blue"></v-progress-linear>
          <div class="text-h6 text-center">
            Please enter the <strong>OTP</strong> generated on your
            Authenticator App.
          </div>
          <p class="text-center">
            Ensure you submit the current one because it refreshes every 30
            seconds.
          </p>
        </v-col>
        <v-col cols="8" md="8" xs="8">
          <v-otp-input length="6" v-model="form.otp"></v-otp-input>
        </v-col>
        <v-col cols="3">
          <v-btn
            dark
            color="#00B3FF"
            block
            @click="login1"
            :loading="loading"
            depressed
            >Verify</v-btn
          >
        </v-col>
      </v-card>
    </div>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'warning'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { checkError } from "@/config/errors.js";
import { EmployerService } from "@/services/employer-service.js";
import Snackbars from "@/components/shared/Snackbars";
import Alert from "@/components/shared/Alert";

export default {
  name: "SwitchRole",
  components: { Snackbars, Alert },
  data() {
    return {
      form: {
        otp: "",
      },
      receivedData: "",
      selectedRole: null,
      errors: null,
      role: localStorage.getItem("role"),
      logo: require("@/assets/logo.png"),
      loading: false,
      snackbar: false,
      successMsg: "You seem to have entered an invalid OTP",
    };
  },

  computed: {
    ...mapGetters("auth", {
      profile: "profile",
      username: "username",
      password: "password",
    }),
  },

  watch: {
    username(value) {
      if (!value) {
        this.redirectToLogin();
      }
    },
    password(value) {
      if (!value) {
        this.redirectToLogin();
      }
    },
  },

  created() {
    this.checkCredentials();
  },

  methods: {
    checkCredentials() {
      if (!this.username || !this.password) {
        this.redirectToLogin();
        return false;
      }
      return true;
    },
    redirectToLogin() {
      this.$router.push("/login");
    },
    login1() {
      if (!this.checkCredentials()) return;

      this.onDismissed();
      let fd = new FormData();
      fd.append("one_time_password", this.form.otp);
      fd.append("username", this.username);
      fd.append("password", this.password);
      this.loading = true;
      EmployerService.googleVerify(fd)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            if (response.data["status"] === "success") {
              this.login(this.username, this.password);
            } else {
              this.loading = false;
              this.form.otp = "";
              this.snackbar = true;
            }
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    login(username1, password1) {
      this.$store
        .dispatch("auth/retrieveToken", {
          username: username1,
          password: password1,
        })
        .then((response) => {
          if (response.status == 200) {
            this.loading = false;
            this.showLogin = false;
            if (response.data.roles && response.data.roles.length > 0) {
              this.$router.push("/switch-role");
            } else {
              this.$router.push("/");
            }
          }
        });
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    onDismissed() {
      this.errors = null;
    },
  },
};
</script>

